import { createStore } from 'vuex'
import auth from './modules/auth'
import components from './modules/components'
import kanban from './modules/kanban'
import routes from './modules/routes'
import settings from './modules/settings'
import user from './modules/user'
import storyManage from './modules/storyManage'
import track from './modules/track'

const modules = {
  auth,
  components,
  kanban,
  routes,
  settings,
  user,
  storyManage,
  track
}
Object.keys(modules).forEach((key) => {
  modules[key]['namespaced'] = true
})
export default createStore({
  modules,
})
